module.exports = __webpack_public_path__ + "img/logo.1f29277.png";